import { Alert, Button, IconButton, MenuItem, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Loader from "../../Tools/Loader";
import moment from "moment";
import API from "../../../services/API/API";
import { Add, Close, Delete } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { useParams } from "react-router-dom";

export default function Improvements(){

    const {course} = useParams()

    const [items, setItems] = useState([])

    const [item, setItem] = useState({})

    const [status, setStatus] = useState('loading')

    const statusIs = str => str === status

    const statusIn = arr => arr.includes(status)

    useEffect(() => {

        API.get(`/courses/${course}/improvements`)
            .then(r => {
                setItems(Array.isArray(r.data) ? r.data : [])
                setStatus('table')
            })
            .catch(e => console.log(e?.response?.data))

    }, [course])

    const handleDelete = id => {

        if(!window.confirm("Êtes vous sûr de vouloir supprimer cette action ?")) return false;

        API.delete(`/improvements/${id}`)
            .then(r => setItems([...items].filter(i => i.id !== id)))
    }

    const handleSubmit = e => {
        e.preventDefault();

        setStatus('submit')

        API.post(`/courses/${course}/improvements`, item)
            .then(r => {
                console.log(r.data)
                let copy = [...items];
                copy.push(r.data)
                setItems(copy)
                setStatus('table')
            })
            .catch(e => {
                console.error(e?.response?.data)
                setStatus('error')
            })
        
    }

    const handleAdd = () => {
        setItem({madeOn: moment().format('YYYY-MM-DD')})
        setStatus('form')
    }
    

    return <Stack spacing={1}>

        <Alert severity='info'>
            Après avoir analysé et identifié les actions à améliorer, nous vous fournissons cet outil de planification. Il vous aidera à rendre ces actions concrètes, faisables, organisées et à les suivre dans le temps.
            <br/>
            Pour commencer, cliquez sur le bouton "ajouter une action", saisissez les mesures à appliquer et déterminez un calendrier pour leur mise en œuvre.
        </Alert>

        {statusIs('loading') && <Loader />}

        {statusIs('table') && <Stack>
            <TableContainer component={Paper} variant='outlined'>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Numéro</TableCell>
                            <TableCell>Action corrective</TableCell>
                            <TableCell>Facilité de mise en place</TableCell>
                            <TableCell>Faisabilité financière</TableCell>
                            <TableCell>Mise en place le</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {items.map((i,n) => 
                            <TableRow key={i.id}>
                                <TableCell>{n + 1}</TableCell>
                                <TableCell>{i.title}</TableCell>
                                <TableCell>{i.setup}/10</TableCell>
                                <TableCell>{i.means}/10</TableCell>
                                <TableCell>{moment(i.madeOn).format('DD/MM/YYYY')}</TableCell>
                                <TableCell>
                                    <IconButton onClick={() => handleDelete(i.id)}>
                                        <Delete/>
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            <Button startIcon={<Add/>} onClick={handleAdd}>Ajouter une action</Button>

        </Stack>}

        {statusIn(['form','submit','error']) && 

            <form onSubmit={handleSubmit}>

                <Stack spacing={3} sx={{maxWidth: 500, margin: 'auto'}}>
                    
                    <Stack direction='row' justifyContent='space-between' alignItems='center'>
                        <Typography variant='h5'>Ajouter une action</Typography>
                        <IconButton onClick={() => setStatus('table')}>
                            <Close/>
                        </IconButton>
                    </Stack>

                    {statusIs('error') && 
                        <Alert severity='error'>Une erreur s'est produite. Vérifiez le formulaire et réessayez.</Alert>
                    }

                    <TextField 
                        label="Action corrective"
                        value={item?.title || ''}
                        onChange={e => setItem({...item, title: e.target.value})}
                        required
                        inputProps={{maxLength: 255}}
                        size='small'
                    />

                    <TextField 
                        label="Facilité de mise en place"
                        value={item?.setup || ''}
                        onChange={e => setItem({...item, setup: parseInt(e.target.value || 1)})}
                        required
                        size='small'
                        select
                        helperText="Note de 1 (non faisable) à 10 (faisable)"
                    >
                        <MenuItem value={1}>1/10</MenuItem>
                        <MenuItem value={2}>2/10</MenuItem>
                        <MenuItem value={3}>3/10</MenuItem>
                        <MenuItem value={4}>4/10</MenuItem>
                        <MenuItem value={5}>5/10</MenuItem>
                        <MenuItem value={6}>6/10</MenuItem>
                        <MenuItem value={7}>7/10</MenuItem>
                        <MenuItem value={8}>8/10</MenuItem>
                        <MenuItem value={9}>9/10</MenuItem>
                        <MenuItem value={10}>10/10</MenuItem>
                    </TextField>

                    <TextField 
                        label="Faisabilité financière"
                        value={item?.means || ''}
                        onChange={e => setItem({...item, means: parseInt(e.target.value || 1)})}
                        required
                        size='small'
                        select
                        helperText="Note de 1 (non faisable) à 10 (faisable)"
                    >
                        <MenuItem value={1}>1/10</MenuItem>
                        <MenuItem value={2}>2/10</MenuItem>
                        <MenuItem value={3}>3/10</MenuItem>
                        <MenuItem value={4}>4/10</MenuItem>
                        <MenuItem value={5}>5/10</MenuItem>
                        <MenuItem value={6}>6/10</MenuItem>
                        <MenuItem value={7}>7/10</MenuItem>
                        <MenuItem value={8}>8/10</MenuItem>
                        <MenuItem value={9}>9/10</MenuItem>
                        <MenuItem value={10}>10/10</MenuItem>
                    </TextField>

                    <TextField 
                        label="Mis en place le"
                        type='date'
                        value={item?.madeOn || ''}
                        onChange={e => setItem({...item, madeOn: e.target.value})}
                        required
                        size='small'
                    />

                    <LoadingButton
                        variant='contained'
                        loading={statusIs('loading')}
                        type='submit'
                    >
                        Valider
                    </LoadingButton>

                </Stack>
            </form>
        }

    </Stack>

}